import { FC, useRef, useState } from "react";
import GlobeIconSVG from "../resources/svg/GlobeIconSVG";
import { useTranslation } from "react-i18next";
import languageServiceFactory from "../../services/LanguageServiceImpl";
import { Languages } from "../../domain/enums/common/LanguagesEnum";
import { useClickOutOfElement } from "../../custom-hooks/base-hooks/useClickOutOfElement";
import DropdownArrowSVG from "../resources/svg/functional/DropdownArrowSVG";
import CheckMarkIconSVG from "../resources/svg/CheckMarkIconSVG";

const languageService = languageServiceFactory();

const FooterLanguageChange: FC = () => {
    const { t } = useTranslation();
    const tooltipRef = useRef(null);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    useClickOutOfElement(tooltipRef, () => setIsTooltipVisible(false));
    const handleChangeLanguage = (lang: Languages) => {
        languageService.setCurrentLang(lang);
        languageService.notifyListeners(lang);
        setIsTooltipVisible(false);
    };

    return (
        <div ref={tooltipRef} className="relative flex justify-center items-center mr-9 tmax4:mr-0 tmax4:mb-3 group">
            <GlobeIconSVG className="w-8 dmax2:w-6 h-8 dmax2:h-6 text-textFaded group-hover:text-textWhite transition-all duration-300" />
            <div
                onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                className="flex justify-center items-center cursor-pointer"
            >
                <span className="H20 td4:H16 tmax4:H14 text-textFaded group-hover:text-textWhite ml-3 transition-all duration-300">
                    {t("common.languageOfWebsite")}
                </span>
                <span className="H20B td4:H16B tmax4:H14B text-textWhite ml-2 mr-2">
                    {t(`languages.short.${languageService.currentLang}`)}
                </span>
                <DropdownArrowSVG className="tmax4:w-4 tmax4:h-[8px] text-textFaded group-hover:text-textWhite transition-all duration-300" />
            </div>
            <div
                className={`absolute top-10 right-0 z-10 bg-backgroundInput w-[160px] h-[96px] py-4 px-6 rounded-[7px] transition-all duration-300 ${
                    isTooltipVisible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
                }`}
            >
                {languageService.langs.map((lang, index) => (
                    <p
                        className={`relative H20 text-textWhite text-center w-[112px] h-[32px] ${
                            index === lang.length - 1 ? "" : "border-b border-textFaded"
                        } ${
                            index !== 0 ? "mt-[12px]" : ""
                        } hover:font-[500] cursor-pointer transition-all duration-300`}
                        onClick={() => handleChangeLanguage(lang)}
                        key={`p-language-selection-${lang}`}
                    >
                        {t(`languages.short.${lang}`)}
                        {languageService.isCurrentLang(lang) && (
                            <CheckMarkIconSVG className="absolute top-[5px] right-[15px]" />
                        )}
                    </p>
                ))}
            </div>
        </div>
    );
};

export default FooterLanguageChange;
